// height in px of 60 min slot
export const HOUR_PX = 112;
export const lEFT_OFFSET = 52;

// ms per minute
export const MS_MULTIPLIER = 60000;

// if an appt duration is null, use 30
export const APPT_DURATION_FALLBACK = 30;

// show button to join appts 5 mins before they start
export const JOIN_APPT_BEFORE_MINS = 5